import React, { useContext } from 'react';
import {
	DishFullInfoContext,
	IDishFullInfoContext,
} from '../../../../../../../../../dishFullInfoState/dishFullInfoContext';
import Text from 'components/Text/Text';
import ChunkOfTextWithCopying from 'components/Text/ChunkOfTextWithCopying';
import style from './SuggestedDishesField.module.scss';

const SuggestedDishesField: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return (
		<div className={style.container}>
			<Text
				translationNameSpace="form"
				translationKey="suggestedDishesCountLabel"
				translationOptions={{ count: dishForFullInfo?.suggestedDishes.length }}
				theme="neutralLight"
				size="xs"
			/>
			<div className={style.suggestedList}>
				{dishForFullInfo?.suggestedDishes.length
					? dishForFullInfo.suggestedDishes.map((el) => {
							return (
								<div key={el.suggestedId} className={style.item}>
									<div className={style.dot} />
									<Text translationKey={el.suggestedName} size="s" withTooltip={true} />
									{el.externalId && (
										<ChunkOfTextWithCopying text={el.externalId} className={style.externalId} />
									)}
								</div>
							);
					  })
					: '-'}
			</div>
		</div>
	);
};

export default SuggestedDishesField;
